import React, { Component } from "react";
import { Link } from "react-router-dom";

class ClaimCreateCash extends Component {
  render() {
    return (
      <div style={{ padding: 24 }}>
        <div style={{ marginBottom: 22 }}>
          <h4 style={{ margin: 0, fontWeight: 900, color: "#0F172A" }}>
            Create Cash Claim
          </h4>
          <p style={{ margin: "6px 0 0", color: "#64748B", fontSize: 13 }}>
            Step 1 of 3: Provide claim details and expense items.
          </p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 320px", gap: 22 }}>
          <div>
            <div style={card}>
              <h5 style={sectionTitle}>Claim Information</h5>

              <div style={grid4}>
                {this.renderInput("Employee Name *", "Allistair Lorenzo James")}
                {this.renderInput("Employee ID", "TR-2024-0105", true)}
                {this.renderInput("Department *", "CRM & ICT")}
                {this.renderInput("Position", "Senior Executive - Digital Development")}
                {this.renderInput("Period *", "Nov-24")}
                {this.renderInput("Claim Reference *", "CC-2024-0112")}
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Expense Items</h5>

              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#F8FAFC" }}>
                    {["#", "Date", "Ref #", "Description / Explanation of Expenses", "Project Account Code", "Total Amount Claimed (RM)", "Action"].map(
                      (h) => (
                        <th key={h} style={thStyle}>{h}</th>
                      )
                    )}
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["1", "03 Nov 2024", "INV-241103-001", "Level Up Fitness Gym membership for Nov 2024", "Staff Welfare", "999.00"],
                    ["2", "30 Nov 2024", "RCPT-241130-002", "Dental Composite Filling", "Staff Medical", "999.00"],
                    ["3", "20 Nov 2024", "RCPT-241120-003", "Mileage Claim (As attached)", "Staff Petrol", "5,994.00"],
                    ["4", "Select date", "eg. INV-0001", "Enter description / explanation", "Select account code", "0.00"],
                  ].map((row) => (
                    <tr key={row[0]} style={{ borderTop: "1px solid #E5E7EB" }}>
                      <td style={tdStyle}>{row[0]}</td>
                      <td style={tdStyle}><input value={row[1]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[2]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[3]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[4]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[5]} readOnly style={{ ...tableInput, textAlign: "right" }} /></td>
                      <td style={tdStyle}><button style={deleteButton}>🗑</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <button style={{ ...secondaryButton, marginTop: 14 }}>+ Add Expense Item</button>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: 14,
                  marginTop: 18,
                }}
              >
                <div style={{ fontWeight: 900 }}>TOTAL EXPENSES (RM)</div>
                <div style={totalBox}>7,992.00</div>
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Supporting Documents (Receipts)</h5>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
                <div style={uploadBox}>
                  <div style={{ fontSize: 30 }}>☁</div>
                  <div style={{ marginTop: 8, color: "#64748B" }}>
                    Drag and drop files here, or <b>click to browse</b>
                  </div>
                  <div style={{ fontSize: 12, color: "#94A3B8", marginTop: 6 }}>
                    PDF, JPG, PNG up to 10MB each
                  </div>
                </div>

                <div>
                  <div style={{ fontWeight: 900, marginBottom: 10 }}>Uploaded Files (3)</div>
                  {["Receipt_Gym_Nov2024.pdf", "Receipt_Dental_301124.jpg", "Mileage_Claim_201124.pdf"].map(
                    (file) => (
                      <div key={file} style={fileRow}>
                        <span>{file}</span>
                        <span style={{ color: "#94A3B8" }}>×</span>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Declaration</h5>
              <label style={{ display: "flex", gap: 10, fontSize: 13, color: "#334155" }}>
                <input type="checkbox" defaultChecked />
                I hereby declare that the information provided is true and correct.
              </label>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18, marginTop: 18 }}>
                {this.renderInput("Signature of Employee", "Allistair Lorenzo James")}
                {this.renderInput("Date", "20 May 2024")}
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 18 }}>
              <Link to="/claim/create" style={secondaryLink}>Back</Link>
              <div style={{ display: "flex", gap: 10 }}>
                <button style={secondaryButton}>Save Draft</button>
                <button style={primaryButton}>Submit Claim ›</button>
              </div>
            </div>
          </div>

          <div>
            <div style={sideCard}>
              <h5 style={sectionTitle}>Claim Summary</h5>
              {this.renderSideRow("No. of Expense Items", "3")}
              {this.renderSideRow("Total Amount Claimed", "RM 7,992.00")}
              {this.renderSideRow("Period", "Nov-24")}
              {this.renderSideRow("Claim Reference", "CC-2024-0112")}
            </div>

            <div style={sideCard}>
              <h5 style={sectionTitle}>Claim Guidance</h5>
              <ul style={sideText}>
                <li>Only claim up to the last three months from today’s date.</li>
                <li>Ensure all receipts are clear and legible.</li>
                <li>Claims without supporting documents may be returned.</li>
              </ul>
            </div>

            <div style={sideCard}>
              <h5 style={sectionTitle}>Policy Notes</h5>
              <ul style={sideText}>
                <li>All claims must be for valid business purposes.</li>
                <li>Misuse of claim privileges may result in disciplinary action.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderInput(label, value, disabled = false) {
    return (
      <div>
        <label style={labelStyle}>{label}</label>
        <input value={value} readOnly disabled={disabled} style={inputStyle} />
      </div>
    );
  }

  renderSideRow(label, value) {
    return (
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
        <span style={{ color: "#64748B", fontSize: 13 }}>{label}</span>
        <b style={{ color: "#0F172A", fontSize: 13 }}>{value}</b>
      </div>
    );
  }
}

const card = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 18,
  marginBottom: 16,
};

const sideCard = {
  ...card,
  marginBottom: 16,
};

const sectionTitle = {
  margin: "0 0 16px",
  fontWeight: 900,
  color: "#0F172A",
};

const grid4 = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: 16,
};

const labelStyle = {
  display: "block",
  fontSize: 12,
  fontWeight: 800,
  color: "#334155",
  marginBottom: 8,
};

const inputStyle = {
  width: "100%",
  height: 38,
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 13,
  outline: "none",
  background: "#fff",
};

const thStyle = {
  padding: "10px 12px",
  textAlign: "left",
  fontWeight: 900,
  fontSize: 12,
  color: "#334155",
  whiteSpace: "nowrap",
};

const tdStyle = {
  padding: 8,
  fontSize: 13,
  color: "#334155",
};

const tableInput = {
  width: "100%",
  height: 34,
  border: "1px solid #E5E7EB",
  borderRadius: 6,
  padding: "0 10px",
  fontSize: 12,
  background: "#fff",
};

const totalBox = {
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "10px 16px",
  minWidth: 170,
  textAlign: "right",
  fontWeight: 900,
  fontSize: 18,
};

const uploadBox = {
  border: "1px dashed #CBD5E1",
  borderRadius: 12,
  padding: 28,
  textAlign: "center",
  color: "#334155",
};

const fileRow = {
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  padding: "10px 12px",
  marginBottom: 8,
  display: "flex",
  justifyContent: "space-between",
  fontSize: 13,
};

const deleteButton = {
  border: "1px solid #FECACA",
  color: "#DC111C",
  background: "#fff",
  borderRadius: 6,
  width: 32,
  height: 32,
};

const primaryButton = {
  background: "#DC111C",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "11px 22px",
  fontWeight: 900,
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "10px 18px",
  fontWeight: 800,
};

const secondaryLink = {
  ...secondaryButton,
  textDecoration: "none",
};

const sideText = {
  color: "#64748B",
  fontSize: 13,
  lineHeight: "22px",
  paddingLeft: 18,
};

export default ClaimCreateCash;